var map = {
	"./0.png": 6914,
	"./1.png": 1739,
	"./2.png": 3408,
	"./3.png": 1529,
	"./4.png": 7798,
	"./5.png": 4735,
	"./6.png": 7876,
	"./7.png": 1773,
	"./8.png": 3994,
	"./9.png": 1747,
	"./dowjonestar-button-date.png": 1704,
	"./dowjonestar-header-2.png": 9859,
	"./dowjonestar-header.png": 874,
	"./dowjonestar-icon.png": 9110,
	"./dowjonestar-image-logo.png": 4176,
	"./dowjonestar-result.png": 1026,
	"./dowjonestar-warpper.png": 8686,
	"./menu.png": 4833,
	"./refresh.png": 7363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7899;